import React from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import {
  getAuthenticatedHomePath,
  hasAuthSession,
} from "../../helpers/routeAccess"

/**
 * Onboarding routes require an authenticated member session.
 * Completed onboarding sends users to their home dashboard.
 */
const OnboardingMiddleware = ({ children }) => {
  const authToken = useSelector(state => state.auth.jid)
  const currentUser = useSelector(state => state.auth.currentUser)
  const isOnboardingComplete = useSelector(
    state => state.onboarding?.isComplete === true,
  )

  if (!hasAuthSession(authToken) || !currentUser) {
    return <Navigate to="/login" replace />
  }

  if (isOnboardingComplete) {
    return <Navigate to={getAuthenticatedHomePath(currentUser)} replace />
  }

  return children
}

export default OnboardingMiddleware
